// hooks/useIntakeArtist.ts
import { useQuery } from "@tanstack/react-query";
import { fetchCommissionArtist, type IntakeApiError } from "../api/intakeApi";
import type { IntakeArtist } from "../types";

export function useIntakeArtist(slug: string | undefined) {
  return useQuery<IntakeArtist, IntakeApiError>({
    queryKey: ["intake-artist", slug],
    queryFn: () => fetchCommissionArtist(slug!),
    enabled: !!slug,
    staleTime: 60_000,
    retry: (n, err) => err.status !== 404 && err.status !== 400 && n < 2,
  });
}
